// src/hooks/useAllGames.js
import { useEffect, useState } from "react";
import {
  loadAllGames,
  getAllGamesSync,
  isAllGamesLoaded,
} from "../data/allGames";

export function useAllGames() {
  const [games, setGames] = useState(getAllGamesSync());
  const [loading, setLoading] = useState(!isAllGamesLoaded());

  useEffect(() => {
    let cancelled = false;

    async function go() {
      try {
        const all = await loadAllGames();
        if (!cancelled) {
          setGames(all);
          setLoading(false);
        }
      } catch (err) {
        console.error("useAllGames error:", err);
        if (!cancelled) setLoading(false);
      }
    }

    if (!isAllGamesLoaded()) {
      go();
    }

    return () => {
      cancelled = true;
    };
  }, []);

  return { games, loading };
}
